import React from "react";
import {connect} from "react-redux";
import {modal} from "@mc/mc-legacy";
import CustomPageLayout from "./CustomPageLayout";
import AdminMenu from "../administrace/lists/components/AdminMenu";
import IconButton from "../components/IconButton";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";
import * as configurationActions from "../actions/configurationActions";
import SignConfigurationForm from "../administrace/forms/SignConfigurationForm";
import SignConfigurationsList from "../administrace/lists/components/SignConfigurationsList";
import {cleanSigners} from "../utils/appUtils";

/**
 * Správa podepisujících.
 */
class SignConfigurationsPage extends React.Component {
    handleCreateSigner = () => {
        const {dispatch} = this.props;
        dispatch(
            modal.ModalActions.show(
                SignConfigurationForm,
                {
                    onSubmit: (data) => {
                        const {signers, typesCombination, ...other} = data;
                        const dataFinal = {
                            ...other,
                            typesCombinationId: typesCombination.id,
                            signers: cleanSigners(signers),
                        };
                        return QSignAdminApi.createConfiguration(dataFinal);
                    },
                    onSubmitSuccess: (result, dispatch) => {
                        dispatch(modal.ModalActions.hide());
                        dispatch(configurationActions.fetchSignConfigurationsIfNeeded(true));
                    },
                    initialValues: {signers: [{}]},
                },
                "Nová konfigurace", {
                    // size: "lg",
                }
            )
        );
    };

    render() {
        return (
            <CustomPageLayout
                header
                customHeaderButton={<IconButton icon="plus" title="Nová konfigurace"
                                                onClick={this.handleCreateSigner}/>}
                headerButton={false}
                searchField={false}
                title="Podpisové konfigurace"
                menu={<AdminMenu/>}
            >
                <SignConfigurationsList/>
            </CustomPageLayout>
        );
    }
}

function mapStateToProps(state) {
    return state;
}

export default connect(mapStateToProps)(SignConfigurationsPage);
